import React from "react";

export function timeAgo(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const fr = lang === "fr";
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return fr ? "à l'instant" : "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return fr ? `il y a ${m} min` : `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return fr ? `il y a ${h} h` : `${h}h ago`;
  const dd = Math.floor(h / 24);
  if (dd < 7) return fr ? `il y a ${dd} j` : `${dd}d ago`;
  return d.toLocaleDateString(fr ? "fr-FR" : "en-US", { day: "numeric", month: "short", year: "numeric" });
}

export const personOf = (a) => ({ name: a?.actor_name, picture: a?.actor_picture });

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Lightweight inline markdown for a plain-text segment (no mentions inside).
// Supports **bold**, *italic*, `code`, [label](url) and bare http(s) links.
const INLINE_RE = /\*\*(.+?)\*\*|`(.+?)`|\*(.+?)\*|\[(.+?)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s]+)/g;

function renderInline(text, keyPrefix) {
  if (!text) return [];
  const out = [];
  let last = 0, m, k = 0;
  const link = (href, label) => (
    <a key={`${keyPrefix}l${k++}`} href={href} target="_blank" rel="noopener noreferrer"
      className="text-blue-600 underline underline-offset-2 break-all hover:opacity-80"
      onClick={(e) => e.stopPropagation()}>{label}</a>
  );
  while ((m = INLINE_RE.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    if (m[1] !== undefined) out.push(<strong key={`${keyPrefix}b${k++}`} className="font-semibold">{m[1]}</strong>);
    else if (m[2] !== undefined) out.push(<code key={`${keyPrefix}c${k++}`} className="px-1 py-0.5 rounded bg-surface-hover text-[0.85em] font-mono">{m[2]}</code>);
    else if (m[3] !== undefined) out.push(<em key={`${keyPrefix}i${k++}`} className="italic">{m[3]}</em>);
    else if (m[4] !== undefined) out.push(link(m[5], m[4]));
    else if (m[6] !== undefined) out.push(link(m[6], m[6]));
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

// Render free text with @Name mentions highlighted + lightweight inline markdown.
export function renderWithMentions(text, members) {
  if (!text) return null;
  const names = (members || []).map((m) => m.name).filter(Boolean);
  names.push("everyone");
  names.sort((a, b) => b.length - a.length);
  const re = new RegExp("@(" + names.map(esc).join("|") + ")", "g");
  const out = [];
  let last = 0, m, k = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(...renderInline(text.slice(last, m.index), `s${k}`));
    out.push(<span key={`mn${k++}`} className="text-blue-600 font-semibold bg-blue-50 rounded px-0.5">@{m[1]}</span>);
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(...renderInline(text.slice(last), `s${k}`));
  return out;
}

export function fmtBytes(n) {
  if (n == null) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
